import { Component, OnInit, Input, ComponentFactoryResolver, Injector, ApplicationRef, ComponentRef, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { IncidenciaLlistaComponent } from '../markers/incidencia-llista/incidencia-llista.component';

/**
 * Component amb un llistat d'incidències visibles als límits del mapa
 */
@Component({
  selector: 'app-llista-incidencies',
  templateUrl: './llista-incidencies.component.html',
  styleUrls: ['./llista-incidencies.component.css']
})
export class LlistaIncidenciesComponent implements OnInit {

  /**
   * Constructor del component
   * @param {ComponentFactoryResolver} resolver Serveix com a Factory pels components que es carreguen dins la finestra d'informació del mapa 
   * @param {ElementRef} elementRef Serveix per mantenir una referència d'algun element de la plantilla del component 
   */
  constructor(private resolver: ComponentFactoryResolver, private elementRef: ElementRef) { }

  /**
   * Conté tots els marcadors d'incidències presents al mapa
   */
  private llistaIncidencies; 

  /**
   * @ignore
   */
  private bindedLlistaIncidencies;
  
  /**
   *  Mapa de l'aplicació 
   */
  @Input() map: google.maps.Map; 

  /**
   * Finestra d'informació del mapa map
   */
  @Input() infowindow: google.maps.InfoWindow;

  /**
   * Inicialitza el valor del llistat d'incidències visibles
   */
  @Input() set setLlistaIncidencies(value) {
    this.llistaIncidencies = value;
  }

  /**
   * Emet al mapa l'event de click sobre una incidència per mostrare el seu marcador
   */
  @Output() clickEmitter = new EventEmitter<any>();

  /**
   * @ignore
   */
  @HostListener('window:resize')
  onResize() {
    this.setScreenSize();
  }

  /**
   * Retorna la llista d'incidències
   */
  get getLlistaIncidencies() {
    this.bindedLlistaIncidencies = this.llistaIncidencies;
    return this.bindedLlistaIncidencies;
  }

  /**
   * Indica si s'ha de mostrar o no el llsitat
   */
  mostraLlistat = false;

  /**
   * Indica si s'ha d'expandir o no el llistat
   */
  expandMenu = false;

  /**
   * Indica l'altura de la pantalla
   */
  screenHeight: number = 100;

  /**
   * Indica l'amplada de la pantalla
   */
  screenWidth: number = 100; // Indica l'amplada de la pantalla


  /**
   * Actualitza els valors de l'alçada i amplada de la pantalla
   */
  setScreenSize(): void{
    this.screenHeight = window.innerHeight;
    this.elementRef.nativeElement.style.setProperty('--height', this.screenHeight + 'px');
    this.screenWidth = window.innerWidth;
    this.elementRef.nativeElement.style.setProperty('--width', this.screenWidth + 'px');
  }

  /**
   * Canvia el valor de la variable mostraLlistat
   */
  toggleLlistat(){
    this.mostraLlistat = !this.mostraLlistat;
  }

  /**
   * Expandeix o redueix la llista d'incidències en la vista de mòbil horitzontal
   */
  toggleExpand(){
    this.expandMenu = !this.expandMenu;
  }

  /**
   * Inicialitza el mode de pantalla de l'aplicació
   */
  ngOnInit() {
    this.setScreenSize();
  }

}
